var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-row",class:{ 'content-2col': _vm.display_type !== 'box' }},[_c('div',{staticClass:"col-1",attrs:{"id":"main-col-1"}},[_c('audio-list')],1),_vm._v(" "),_c('div',{staticClass:"col-2",attrs:{"id":"main-col-2"}},[(false)?_c('watchlist'):_vm._e(),_vm._v(" "),_c('navigation')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }